export const TAX_VISIBILITY_HIDDEN = 'hidden';
export const TAX_VISIBILITY_MESSAGE_ONLY = 'message_only';